export async function createCalendar($el, options) {
  // `@fullcalendar/core` must be loaded before its plugins
  const { Calendar } = await import("@fullcalendar/core");
  // prettier-ignore
  const [
    { default: dayGridPlugin },
    { default: listPlugin },
    { default: interactionPlugin },
    { default: timegridPlugin },
    { default: awfusThemePlugin },
  ] = await Promise.all([
    import("@fullcalendar/daygrid"),
    import("@fullcalendar/list"),
    options.selectable || options.dateClick ? import("@fullcalendar/interaction") : { default: null },
    options.initialView === 'timeGridDay' ? import("@fullcalendar/timegrid") : { default: null },
    import("./fc-theme-awfus"),
  ]);

  const locale = await getLocalePlugin();

  const plugins = [dayGridPlugin, listPlugin, interactionPlugin, timegridPlugin, awfusThemePlugin].filter(Boolean);

  const calendar = new Calendar($el, {
    plugins: plugins,
    locale: locale,
    initialView: "dayGridMonth",
    themeSystem: "awfus",
    weekNumbers: true,
    headerToolbar: {
      left: "prev,next,today",
      center: "title",
      right: "dayGridMonth,listYear",
    },
    viewDidMount: () => {
      const setIcon = (button, icon) => {
        button.classList.add("button--icon-only");
        button.innerHTML = `<svg class="icon" fill="currentColor"><use href="/icons/sprite.svg#${icon}"></use></svg>`;
      };
      $el.querySelectorAll(".fc-prev-button,.fc-next-button").forEach((button) => {
        if (button.classList.contains("fc-prev-button")) {
          setIcon(button, "chevron--left");
        }
        if (button.classList.contains("fc-next-button")) {
          setIcon(button, "chevron--right");
        }
      });
    },
    ...options,
  });

  calendar.render();

  return calendar;
}

/**
 * Import the necessary locale plugin for FullCalendar.
 *
 * @param {String} [locale] - The locale to load, defaults to the current locale.
 * @returns {Promise<import("@fullcalendar/common").LocaleInput>}
 */
export async function getLocalePlugin(locale = window._locale) {
  let promise;

  switch (locale) {
    case "en":
      promise = import("@fullcalendar/core/locales/en-gb");
      break;
    case "es":
      promise = import("@fullcalendar/core/locales/es");
      break;
    case "de":
      promise = import("@fullcalendar/core/locales/de");
      break;
    default:
      promise = import("@fullcalendar/core/locales/fr");
      break;
  }

  return promise.then((module) => module.default);
}
